<!--
 * @Author: maqian maqian@aeonmed.com
 * @Date: 2025-04-28 11:00:49
 * @LastEditors: maqian maqian@aeonmed.com
 * @LastEditTime: 2025-08-22 15:23:22
 * @FilePath: \shh-download\src\components\luvlink.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: maqian
 * @Date: 2023-12-25 16:39:59
 * @LastEditors: maqian maqian@aeonmed.com
 * @LastEditTime: 2025-03-14 14:24:40
 * @Description:
-->
<template>
    <div class="page-container">
        <div class="top">
          <img src="@/assets/yian.png"/>
          <div class="title">LuvLink APP:</div>
          <div style="font-size: 16px;">
            Effortless WiFi Setup for Your Heyer AS/BF Series Devices
            <br />
            Simplify Device Configuration in Seconds
          </div>
        </div>
        <div class="bottom">
          <div class="download-btn" @click="downloadIOS">
            <img src="@/assets/apple.png"/>
            <div>IPhone</div>
            <div>Download</div>
          </div>
          <div class="download-btn"  @click="downloadAndroid">
            <img src="@/assets/google.png"/>
            <div>Google</div>
            <div>Download</div>
          </div>
        </div>
        <div style="font-size:12px; margin-top: 50px; padding-bottom: 24px;">E-mail：marketing@heyermed.com</div>
    </div>
  </template>
<script>
export default {
  methods: {
    downloadIOS () {
      window.open('https://apps.apple.com/app/luvlink/id6743191754')
    },
    downloadAndroid () {
      window.open('https://play.google.com/store/apps/details?id=com.aeonmed.luvlink')
    }
  }
}
</script>
  <style scoped>
  .page-container{
    text-align: center;
  }
  .top{
    width: 100%;
    height: 497px;
    font-size: 18px;
    font-weight: 400;
    background: linear-gradient( 180deg, #F0FDFF 0%, #FFFFFF 100%);
  }
  .top img{
    width: 70px;
    height: 70px;
    margin-top: 150px;
    margin-bottom: 40px;
  }
  .top .title{
    font-weight: 600;
  }
  .top div{
    line-height: 25px;
  }
  .bottom{
    background: #ffffff;
    margin-top: 45px;
  }
  .download-btn{
    width: 267px;
    height: 58px;
    border-radius: 34px;
    border: 1px solid #999999;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 17px 40px 17px 41px;
    margin: 0 auto 24px;
  }
  .download-btn img{
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .download-btn div:nth-child(2){
    font-size: 18px;
    font-weight: 600;
    flex: 1;
    text-align: left;
  }

  .download-btn div:nth-child(3){
    font-size: 16px;
    font-weight: 400;
    margin-left: 20px;
  }

  </style>



// WEBPACK FOOTER //
// src/components/luvlink.vue